import { CreateAlert } from "../../modules/alert";
import { store } from "../../store/store";
import { getEnv } from "../../AppConfigs";
import Axios from "axios";
import api from "../axiosBase";
import { RequestError } from "../requestError";
import { getURL } from "../serviceHelper";
import axios from "../department-viags/config.service";
import viagsApiDev2 from "../../pages/chats/api/axiosClient";

export interface User {
  id: string;
  hrId: number;
  username: string;
  email: string;
  phoneNumber: string;
  password: string;
  firstName: string;
  lastName: string;
  fullNameNoAccent: string;
  firstNameUnsign: string;
  lastNameUnsign: string;
  gender: null;
  title: null;
  keyword: string;
  refreshToken: null;
  avatar: string;
  avatarMedium: string;
  avatarSmall: string;
  doB: null;
  fullName: string;
}

export interface PermissionItem {
  id: string;
  code: string;
  name: string;
  description: string;
  createdDate: string;
  updatedDate: null;
}

export interface IUserMineInfo {
  user: User;
  permission: PermissionItem[];
}

type ApiResponse<T> = { data: T; statusCode: number };

export class UserService {
  static async auth() {
    const { user } = store.getState();
    if (user) {
      try {
        // Register notification
        // @ts-ignore
        const firebase: any = window["firebase"];
        const messaging = firebase.messaging();
        const notiToken = await messaging.getToken({
          vapidKey: "BCED2_i8U7e3v4L4GiNz1jA0imzoJzPcRD_ZJtQJhJkEhCHoZu4vYtFaZOJzvf3mbupen_mXfNntHQAhL06bpzI",
        });

        Axios.post(`${getEnv("REACT_APP_NOTIFIER_SERVER_API_URL")}/subscribe`, {
          username: user?.current?.username,
          token: notiToken,
          project: getEnv("REACT_APP_NOTIFIER_PROJECT_NAME") || "none",
        });

        messaging.onMessage((payload: any) => {
          CreateAlert({
            title: payload.data.title,
            message: payload.data.body,
          });
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  static async getUsers() {
    return api
      .get(getURL("/users?$select=displayName,id,mail,officeLocation&$orderby=displayName"))
      .then((res) => res.data.value)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getGroups(userId: any) {
    return api
      .get(getURL(`/users/${userId}/memberOf`))
      .then((res) => {
        const result = res.data.value.map((item: any) => UserService.mapGroupData(item));
        return {
          data: result,
          count: result.length,
        };
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMineInfo() {
    const res = await axios.get<ApiResponse<IUserMineInfo>>("qltl/user/getinfomine");
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  static async signInByMsToken(msToken: string) {
    const payload = JSON.stringify(msToken);
    const res = await viagsApiDev2.post("/api/user/signin-by-mstoken", payload);
    return res.data;
  }

  static mapGroupData(groupItem: any) {
    return {
      id: groupItem.id,
      name: groupItem.displayName,
      description: groupItem.description,
      mail: groupItem.mail,
      mailNickName: groupItem.mailNickname,
      mailEnabled: groupItem.mailEnabled,
      resources: groupItem.resourceProvisioningOptions,
      visibility: groupItem.visibility,
    };
  }
}
